function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48.09 48.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-255.18,141l-8.54-8.56a2.2,2.2,0,0,0-3.08,0,2.2,2.2,0,0,0-.64,1.55,2.2,2.2,0,0,0,.64,1.55l8.54,8.53a4.34,4.34,0,0,0,3.09,1.29,4.34,4.34,0,0,0,3.09-1.29l20.16-20.16a2.16,2.16,0,0,0,.65-1.54,2.12,2.12,0,0,0-.65-1.54,2.12,2.12,0,0,0-1.53-.65,2.12,2.12,0,0,0-1.54.65Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -278.35,
    y: 187.08,
    width: 55.37,
    height: 55.37,
    rx: 7.91,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -180.65,
    cy: 214.76,
    r: 28.2,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.43,48.09c-7.21,0-14.82-4-22.64-11.78C3.28,27.8-.65,19.56.09,11.81a16.3,16.3,0,0,1,4-9.54,7.75,7.75,0,0,1,11,0L19.76,7a7.76,7.76,0,0,1,0,11,8.56,8.56,0,0,1-5,2.22,25.85,25.85,0,0,0,5.6,7.56A25.7,25.7,0,0,0,28,33.28a8.5,8.5,0,0,1,2.24-5,7.68,7.68,0,0,1,5.46-2.26h0a7.71,7.71,0,0,1,5.48,2.27L45.82,33a7.76,7.76,0,0,1,0,11,16.3,16.3,0,0,1-9.54,4C35.67,48.06,35.05,48.09,34.43,48.09ZM9.6,4A3.72,3.72,0,0,0,7,5.1c-.41.42-10,10.71,7.66,28.38C22.12,41,29.48,44.64,35.9,44A12.42,12.42,0,0,0,43,41.14a3.74,3.74,0,0,0,0-5.3l-4.68-4.68a3.85,3.85,0,0,0-5.3,0,4.47,4.47,0,0,0-.89,4.23,2,2,0,0,1-.3,1.73,2,2,0,0,1-1.55.82c-.5,0-5.31,0-12.7-7.42s-7.44-12.18-7.42-12.7A2,2,0,0,1,11,16.27,2,2,0,0,1,12.7,16a4.48,4.48,0,0,0,4.23-.89,3.75,3.75,0,0,0,0-5.3L12.25,5.1A3.72,3.72,0,0,0,9.6,4Zm8.74,12.49h0Z",
    style: {
      fill: "currentcolor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.8002bd76.svg";
export { ForwardRef as ReactComponent };